import React from 'react';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../../constants';

const MdnHistoriesTable = ({ mdnHistory }) => {
  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>MDN</th>
            <th>Since</th>
            <th>Until</th>
          </tr>
        </thead>
        <tbody>
          {Boolean(mdnHistory?.length) &&
            mdnHistory.map((history, i) => {
              const { mdn, since_ts, until_ts } = history;
              return (
                <tr key={i}>
                  <td>{mdn}</td>
                  <td>
                    {since_ts
                      ? moment(since_ts).format(DATE_TIME_FORMAT)
                      : since_ts}
                  </td>
                  <td>
                    {until_ts
                      ? moment(until_ts).format(DATE_TIME_FORMAT)
                      : until_ts}
                  </td>
                </tr>
              );
            })}
          {!mdnHistory?.length && (
            <tr>
              <td colSpan="3">No results</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MdnHistoriesTable;
